export const API_BASE_PATH = '/api/v2';
export const REFRESH_ACCESS_TOKEN_API_ENDPOINT = '/auth/token_refresh';
export const SESSION_LOCALE_API_ENDPOINT = '/session_locale';